import querystring from 'query-string';

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * A simple O(1) memoization helper to faciliate shallow-comparsion for
 * validation check.
 * This can only remember last one entry - this should be enough for most
 * rendering purposes.
 * @param {T} func The original function.
 * @return {T} The modified function.
 */
function memoize(func) {
  var prevArgs = null;
  var prevResult = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (prevArgs == null || prevArgs.length !== args.length || prevArgs.some(function (v, i) {
      return v !== args[i];
    })) {
      prevArgs = args;
      prevResult = func.apply(void 0, args);
    }
    return prevResult;
  };
}
var getQuery = memoize(function (url) {
  var _;
  var search = (_ = (/\?(.+)$/.exec(url) || ['', ''])[1]) !== null && _ !== void 0 ? _ : '';
  return querystring.parse(search.replace(/&amp;/g, '&'));
});

export { getQuery, memoize };
//# sourceMappingURL=trackings.js.map
